import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { User } from '@models/users/user.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  static readonly API_PROFILE_BASE_PATH = `${environment.api.rest.profile}`;

  constructor(private http: HttpClient) {
  }

  loadProfile(id: number) {
    return this.http.get<User>(`${ProfileService.API_PROFILE_BASE_PATH}/${id}`);
  }

  updateProfile(id: number, payload: any) {
    return this.http.patch<User>(`${ProfileService.API_PROFILE_BASE_PATH}/${id}`, payload);
  }

  uploadProfilePicture(id: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.patch(`${ProfileService.API_PROFILE_BASE_PATH}/${id}/image`, formData,
      {responseType: 'text'});
  }
}
